module.exports = "input[type='checkbox']:checked + label {\n  text-decoration: none;\n  color: black; }\n\n.scroll-v {\n  max-height: 80vh;\n  overflow-y: auto !important;\n  overflow-x: auto !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/administration/teacher/create-user-login/create-user-login.component.scss
// module id = ./src/app/administration/teacher/create-user-login/create-user-login.component.scss
// module chunks = main